import React from 'react';
import { useSelector } from 'react-redux';

function useVerifyEnvioSingleUser() {
  const { checkout } = useSelector((state) => state.dagpacket);
  const { cart } = checkout;

  // true significa que no existe envios de direrente usuario
  const verifyWhenAddToCart = (envio) => {
    const userIdEnvio = envio.user_id;
    const envioDeDiferenteUsuarioArr = cart.filter((item) => item.user_id !== userIdEnvio);

    if (envioDeDiferenteUsuarioArr.length === 0) {
      return true;
    }

    return false;
  };

  const verifyWhenTryToPay = () => {
    if (cart.length > 0) {
      const idUserToVerify = cart[0]?.user_id;

      const envioDeDiferenteUsuarioArr = cart.filter((item) => item.user_id !== idUserToVerify);

      if (envioDeDiferenteUsuarioArr.length === 0) {
        return true;
      }
      return false;
    }
    return true;
  };

  return { verifyWhenAddToCart, verifyWhenTryToPay };
}

export default useVerifyEnvioSingleUser;
